import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}

const LinkedinIcon: FunctionComponent<Props> = ({
  className = "",
  fill = "",
  width = 40,
  height = 40,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>LinkedIn</title>
      <path
        d="M34 32.9984V22.9409C34 17.5524 31.1451 15.045 27.337 15.045C24.2642 15.045 22.888 16.7477 22.1218 17.9425V15.4564H16.334C16.4105 17.1034 16.334 32.9984 16.334 32.9984H22.1218V23.2014C22.1218 22.6787 22.1592 22.1542 22.3121 21.7806C22.7302 20.7334 23.6818 19.6485 25.2809 19.6485C27.3761 19.6485 28.2138 21.2562 28.2138 23.6144V33L34 32.9984ZM10.2355 13.062C12.2526 13.062 13.5101 11.7133 13.5101 10.0302C13.4726 8.30942 12.2526 7 10.2729 7C8.29323 7 7 8.30779 7 10.0286C7 11.7133 8.25581 13.0604 10.1997 13.0604H10.2355V13.062ZM13.1294 32.9984V15.4564H7.34323V32.9984H13.1294Z"
        fill={fill}
      />
    </svg>
  );
};

export default LinkedinIcon;
